// extracted by mini-css-extract-plugin
export default {"root":"Label__root--3X_np"};